import { useState, useEffect } from "react";
import {
  degrees,
  IndexOutOfBoundsError,
  PDFDocument,
  rgb,
  StandardFonts,
} from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/Realtor CE.pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFont from "../assets/fonts/Roboto-Medium.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";

async function makeFlyerTemplateFive(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);
  // const licensingSplit = userData.brand.Licensing.slice(0, 30); // first line
  // const licensingSplit2 = userData.brand.Licensing.slice(30); // second line

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );

  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFont).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );
  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforRobotoBold = await fetch(RobotoBold).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  const robotoBold = await pdfDoc.embedFont(fontBytesforRobotoBold);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();

  /// Second to Last Page Only
  //
  //
  //
  //
  /// Second to Last Page Only

  const secondToLastPage = pages[pages.length - 2];
  let textWidth = 100;
  let textHeight = 325;

  if (userData.userData.mloHeadshotFinal !== "") {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      secondToLastPage.drawImage(headshot, {
        x: 105,
        y: 170,
        width: 200,
        height: 200,
      });
      textWidth = 340;
    }
  }

  secondToLastPage.drawText(
    `${person.FirstName.toUpperCase()} ${person.LastName.toUpperCase()}`,
    {
      x: textWidth,
      y: 350,
      size: 28,
      font: robotoBold,
      color: rgb(1, 1, 1),
      weight: "bold",
    }
  );
  secondToLastPage.drawText(`${person.Title}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;
  if (person.LoanForce__NMLS_Number__c !== "") {
    secondToLastPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  if (userData.settings.user.mobileNumber) {
    secondToLastPage.drawText(`Mobile: ${person.Mobile_Phone_Formatted__c}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  secondToLastPage.drawText(`Office:  ${person.Phone}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;

  if (userData.settings.user.faxNumber) {
    secondToLastPage.drawText(`Fax:  ${person.Fax}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
    textHeight -= 25;
  }

  secondToLastPage.drawText(`Email: ${person.Email}`, {
    x: textWidth,
    y: textHeight,
    size: 17,
    font: robotoFontCondensed,
    color: rgb(1, 1, 1),
  });
  textHeight -= 25;

  if (userData.settings.user.customMloWebsite === true) {
    secondToLastPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: textWidth,
      y: textHeight,
      size: 17,
      font: robotoFontCondensed,
      color: rgb(1, 1, 1),
    });
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    secondToLastPage.drawText(
      `${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: textWidth,
        y: textHeight,
        size: 17,
        font: robotoFontCondensed,
        color: rgb(1, 1, 1),
      }
    );
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    // set the name of the file
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    const link = document.createElement("a");
    link.href = url2;
    link.download = `${userData.flyerChoice.name}`;
    link.click();
  }
  setLoading(false);
  return pdfBytes;
}

export default makeFlyerTemplateFive;
